import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { RahkaranFormComponent } from "../rahkaran-form/rahkaran-form.component";
import { OrderService } from "src/app/frontoffice/order/order.service";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
@Component({
  selector: "ngx-rahkaran-list",
  templateUrl: "./rahkaran-list.component.html",
  styleUrls: ["./rahkaran-list.component.scss"],
})
export class RahkaranListComponent extends BaseListComponent {
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, public storage: LocalStoreManager) {
    super();
    this.inputEditorform = RahkaranFormComponent;
  }

  ngOnInit(): void {
    this.apiName = "Rahkaran";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.Pages.PageMenu.Rahkaran");
  }
}
